export const environment = {
  production: true,
  spaBaseUrl: 'https://geia.com.br/#/login',
  apiBaseUrl: 'https://back-end-main.azurewebsites.net/api',
  cotacaoOnline: 'https://portal.geia.com.br/Simulador',

  // Config Sentry
  sentryDsn: 'https://a4adfb4ff19d81bf75d30f872a609ee1@o4509804726714368.ingest.us.sentry.io/4509804737658880', //mudar para o dns de PROD
  sentryTracingOrigins: [
    'front-end-main.azurewebsites.net',
    'geia.com.br',
    /^\//, // para rotas locais
  ],
  environmentName: 'production',
  recaptchaSiteKey: '6LdaWYcsAAAAAIXc5RCQzIIDXrkDTKgm50OCODnf',
};
